import { IconButton, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./App.css";
import RoutesSection from "./routes";
import { SnackbarProvider } from "notistack";
import React from "react";

function App() {
  const notiStackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notiStackRef.current.closeSnackbar(key);
  };
 
  return (
    <>
      <SnackbarProvider
        hideIconVariant
        ref={notiStackRef}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        TransitionComponent={Slide}
        maxSnack={3}
        autoHideDuration={2000}
        action={(key) => (
          <IconButton onClick={onClickDismiss(key)}>
            <CloseIcon htmlColor="white" />
          </IconButton>
        )}
      >
        <RoutesSection />
      </SnackbarProvider>
    </>
  );
}

export default App;
